export default "__VITE_ASSET__c77b35a6__"